export class OrderState {
  public static readonly CODE_OFFEN = 'OFFEN';
  public static readonly CODE_VERF = 'VERF';
  public static readonly CODE_ERL = 'ERL';
  public static readonly CODE_TWOFF = 'TWOFF';
}
